// Note: this control currently violates some principles of good control design on our part -- namely embracing content transclusion for both the link and heading sections.

export class HeadingBinding {
  /** If the heading has the MWF link option, this href value will be populated into the anchor. */
  public href = "@?";

  /** If set to true, the top margin will be hidden from this heading. This is a one-time binding.*/
  public isLean = "<?";

  /** The text to display in place of the heading link. */
  public linkText = "@?";

  /** The size of the heading element. The values used in this property are 1-6, representing H1, H2... H6. This is a one-time binding. Note: This currently does not change the ELEMENT, but only the relative size of the heading, and will be adjusted in the future to change the element as well ( h1 / h2 / h3). */
  public size = "<";

  /** The text to show in the heading itself. */
  public text = "@";
}

export class HeadingController {
  public href: string;
  public isLean: boolean;
  public linkText: string;
  public size: number;
  public text: string;
}
export const sdHeading: ng.IComponentOptions = {
  bindings: <any>new HeadingBinding(),
  controller: HeadingController,
  templateUrl: "../ShellCommon/Controls/Heading/Heading.html"
};
